module.exports = __webpack_public_path__ + "images/royal-canin.sprite-brand2-xs.12deaf0aa466d63197743444d3aebf70.svg";